
import { defineComponent, computed, useStore } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    cookiebotId: { type: String, required: true },
  },
  setup() {
    const store = useStore()
    const culture = computed(() => (store.state.page.page?.language ? store.state.page.page.language.toUpperCase() : undefined))
    return {
      culture,
    }
  },
})
